import type { Component /* , JSX */ } from 'solid-js'
import { splitProps } from 'solid-js'

export const MirrorBulletIcon: Component<{
	/* size?: number | string
	scale?: number | string
	class?: string
	style?: JSX.CSSProperties */
	[x: string]: any
}> = (passedProps) => {
	const [_props, otherProps] = splitProps(passedProps, ['name'])
	const svgEl = (
		<svg xmlns='http://www.w3.org/2000/svg' width={256} height={256} viewBox='0 0 256 256' {...otherProps}>
			<g fill='currentColor'>
				<path
					opacity='0.2'
					d='M235.28000000018628,116.72 L139.23000000018627,20.66 A16,16 0 0 0 116.67000000018626,20.66 L20.670000000186263,116.72 A16,16 0 0 0 20.670000000186263,139.28 L116.72000000018626,235.34 A16,16 0 0 0 139.28000000018628,235.34 L235.33000000018626,139.28 A16,16 0 0 0 235.33000000018626,116.72 L235.28000000018628,116.72 z'
				/>
				<path
					opacity='0.9'
					d='M172.92577785778792,130.48424570452423 L130.48935169506817,172.92067186724395 A3.5098460805416107,3.5098460805416107 0 0 1 125.52075346518308,172.92067186724395 L83.08432730246335,130.48424570452423 A3.5098460805416107,3.5098460805416107 0 0 1 83.08432730246335,125.51564747463911 L125.54285577047617,83.07922131191938 A3.5098460805416107,3.5098460805416107 0 0 1 130.51145400036125,83.07922131191938 L172.94788016308098,125.5377497799322 A3.5098460805416107,3.5098460805416107 0 0 1 172.92577785778792,130.48424570452423'
				/>
			</g>
		</svg>
	) as SVGElement
	return svgEl
}
